import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4775e680"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "antialiased" };
const _hoisted_2 = { class: "my-1" };
const _hoisted_3 = { class: "inline-block min-w-full shadow rounded-lg overflow-y-hidden" };
const _hoisted_4 = { class: "main-table min-w-full leading-normal text-xs" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", { class: "td-release-date" }, "申請日時", -1));
const _hoisted_6 = {
    key: 0,
    class: "td-storeCd"
};
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", { class: "td-customerNo" }, "お客様番号", -1));
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", { class: "td-status" }, "ステータス", -1));
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", { class: "td-crm-link" }, "CRM情報", -1));
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", { class: "td-detail" }, "詳細", -1));
const _hoisted_11 = {
    key: 0,
    class: "w-full"
};
const _hoisted_12 = { class: "td-release-date" };
const _hoisted_13 = { class: "td-p whitespace-nowrap" };
const _hoisted_14 = { class: "td-storeCd" };
const _hoisted_15 = { class: "td-p whitespace-nowrap" };
const _hoisted_16 = { class: "td-customerNo" };
const _hoisted_17 = { class: "td-p whitespace-nowrap" };
const _hoisted_18 = { class: "td-status" };
const _hoisted_19 = {
    key: 0,
    class: "py-1 px-2 bg-red-100 text-red-900 font-semibold rounded-full"
};
const _hoisted_20 = {
    key: 1,
    class: "py-1 px-2 bg-green-100 text-green-900 font-semibold rounded-full"
};
const _hoisted_21 = { class: "td-crm-link" };
const _hoisted_22 = ["onClick"];
const _hoisted_23 = { class: "td-detail" };
const _hoisted_24 = ["onClick"];
const _hoisted_25 = {
    key: 1,
    class: "w-full"
};
const _hoisted_26 = { class: "td-release-date" };
const _hoisted_27 = { class: "td-p whitespace-nowrap" };
const _hoisted_28 = { class: "td-customerNo" };
const _hoisted_29 = { class: "td-p whitespace-nowrap" };
const _hoisted_30 = { class: "td-status" };
const _hoisted_31 = {
    key: 0,
    class: "py-1 px-2 bg-gray-100 text-gray-900 font-semibold rounded-full"
};
const _hoisted_32 = {
    key: 1,
    class: "py-1 px-2 bg-green-100 text-green-900 font-semibold rounded-full"
};
const _hoisted_33 = { class: "td-crm-link" };
const _hoisted_34 = ["onClick"];
const _hoisted_35 = { class: "td-detail" };
const _hoisted_36 = ["onClick"];
const _hoisted_37 = { class: "px-5 py-2 bg-white border-t flex flex-col xs:flex-row items-center xs:justify-between" };
const _hoisted_38 = { key: 0 };
const _hoisted_39 = { class: "flex pl-0 list-none rounded text-xs" };
const _hoisted_40 = ["onClick"];
const _hoisted_41 = { class: "modal-content p-4" };
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "modal-header flex justify-center" }, [
    /*#__PURE__*/ _createElementVNode("label", { class: "modal-title justify-center" }, "変更申請内容詳細")
], -1));
const _hoisted_43 = { class: "main-content my-2 text-md whitespace-pre-wrap" };
const _hoisted_44 = { class: "modal-table flex justify-center overflow-y-scroll" };
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("tr", null, [
    /*#__PURE__*/ _createElementVNode("th", null, [
        /*#__PURE__*/ _createElementVNode("label", { class: "" }, "名前")
    ])
], -1));
const _hoisted_46 = { class: "" };
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("tr", null, [
    /*#__PURE__*/ _createElementVNode("th", null, [
        /*#__PURE__*/ _createElementVNode("label", { class: "" }, "お客様番号")
    ])
], -1));
const _hoisted_48 = { class: "" };
const _hoisted_49 = { key: 0 };
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", null, [
    /*#__PURE__*/ _createElementVNode("label", { class: "" }, "郵便番号")
], -1));
const _hoisted_51 = [
    _hoisted_50
];
const _hoisted_52 = { key: 1 };
const _hoisted_53 = ["onClick"];
const _hoisted_54 = { class: "" };
const _hoisted_55 = { key: 2 };
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", null, [
    /*#__PURE__*/ _createElementVNode("label", { class: "" }, "都道府県")
], -1));
const _hoisted_57 = [
    _hoisted_56
];
const _hoisted_58 = { key: 3 };
const _hoisted_59 = ["onClick"];
const _hoisted_60 = { class: "" };
const _hoisted_61 = { key: 4 };
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", null, [
    /*#__PURE__*/ _createElementVNode("label", { class: "" }, "市区町村")
], -1));
const _hoisted_63 = [
    _hoisted_62
];
const _hoisted_64 = { key: 5 };
const _hoisted_65 = ["onClick"];
const _hoisted_66 = { class: "" };
const _hoisted_67 = { key: 6 };
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", null, [
    /*#__PURE__*/ _createElementVNode("label", { class: "" }, "番地")
], -1));
const _hoisted_69 = [
    _hoisted_68
];
const _hoisted_70 = { key: 7 };
const _hoisted_71 = ["onClick"];
const _hoisted_72 = { class: "" };
const _hoisted_73 = { key: 8 };
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", null, [
    /*#__PURE__*/ _createElementVNode("label", { class: "" }, "電話番号")
], -1));
const _hoisted_75 = [
    _hoisted_74
];
const _hoisted_76 = { key: 9 };
const _hoisted_77 = ["onClick"];
const _hoisted_78 = { class: "" };
const _hoisted_79 = { key: 10 };
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", null, [
    /*#__PURE__*/ _createElementVNode("label", { class: "" }, "携帯番号")
], -1));
const _hoisted_81 = [
    _hoisted_80
];
const _hoisted_82 = { key: 11 };
const _hoisted_83 = ["onClick"];
const _hoisted_84 = { class: "" };
const _hoisted_85 = { class: "modal-footer flex justify-center" };
const _hoisted_86 = {
    key: 1,
    class: "btn btn-gray dialog-button",
    style: { "cursor": "default" },
    disabled: ""
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
    const _directive_tooltip = _resolveDirective("tooltip");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("table", _hoisted_4, [
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _hoisted_5,
                                ($props.isSysAdmin)
                                    ? (_openBlock(), _createElementBlock("th", _hoisted_6, "支店コード"))
                                    : _createCommentVNode("", true),
                                _hoisted_7,
                                _hoisted_8,
                                _hoisted_9,
                                _hoisted_10
                            ])
                        ]),
                        ($props.isSysAdmin)
                            ? (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.displayRequests, (req) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: req.id
                                    }, [
                                        _createElementVNode("td", _hoisted_12, [
                                            _createElementVNode("p", _hoisted_13, _toDisplayString(req.requestedAt), 1)
                                        ]),
                                        _createElementVNode("td", _hoisted_14, [
                                            _createElementVNode("p", _hoisted_15, _toDisplayString(req.storeId), 1)
                                        ]),
                                        _createElementVNode("td", _hoisted_16, [
                                            _createElementVNode("p", _hoisted_17, _toDisplayString(req.customerNo), 1)
                                        ]),
                                        _createElementVNode("td", _hoisted_18, [
                                            (req.isComplated === $data.userUpdateReq.OPEN.code)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString($data.userUpdateReq.OPEN.name), 1))
                                                : (req.isComplated === $data.userUpdateReq.CLOSED.code)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString($data.userUpdateReq.CLOSED.name), 1))
                                                    : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("td", _hoisted_21, [
                                            _createElementVNode("button", {
                                                class: "td-link text-xs",
                                                onClick: ($event) => ($options.crmLink(req.customerId))
                                            }, [
                                                _createVNode(_component_font_awesome_icon, {
                                                    icon: "database",
                                                    size: "lg"
                                                })
                                            ], 8, _hoisted_22)
                                        ]),
                                        _createElementVNode("td", _hoisted_23, [
                                            _createElementVNode("button", {
                                                class: "td-link text-xs",
                                                onClick: ($event) => ($options.openModal(req))
                                            }, [
                                                _createVNode(_component_font_awesome_icon, {
                                                    icon: "external-link-alt",
                                                    size: "lg"
                                                })
                                            ], 8, _hoisted_24)
                                        ])
                                    ]));
                                }), 128))
                            ]))
                            : (_openBlock(), _createElementBlock("tbody", _hoisted_25, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.displayRequests, (req) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: req.id
                                    }, [
                                        _createElementVNode("td", _hoisted_26, [
                                            _createElementVNode("p", _hoisted_27, _toDisplayString(req.requestedAt), 1)
                                        ]),
                                        _createElementVNode("td", _hoisted_28, [
                                            _createElementVNode("p", _hoisted_29, _toDisplayString(req.customerNo), 1)
                                        ]),
                                        _createElementVNode("td", _hoisted_30, [
                                            (req.isComplated === $data.userUpdateReq.OPEN.code)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString($data.userUpdateReq.OPEN.name), 1))
                                                : (req.isComplated === $data.userUpdateReq.CLOSED.code)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString($data.userUpdateReq.CLOSED.name), 1))
                                                    : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("td", _hoisted_33, [
                                            _createElementVNode("button", {
                                                class: "td-link text-xs",
                                                onClick: ($event) => ($options.crmLink(req.customerId))
                                            }, [
                                                _createVNode(_component_font_awesome_icon, {
                                                    icon: "database",
                                                    size: "lg"
                                                })
                                            ], 8, _hoisted_34)
                                        ]),
                                        _createElementVNode("td", _hoisted_35, [
                                            _createElementVNode("button", {
                                                class: "td-link text-xs",
                                                onClick: ($event) => ($options.openModal(req))
                                            }, [
                                                _createVNode(_component_font_awesome_icon, {
                                                    icon: "external-link-alt",
                                                    size: "lg"
                                                })
                                            ], 8, _hoisted_36)
                                        ])
                                    ]));
                                }), 128))
                            ]))
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                        ($data.pageRequestList.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                _createElementVNode("ul", _hoisted_39, [
                                    ($data.nowPage !== 1)
                                        ? (_openBlock(), _createElementBlock("li", {
                                            key: 0,
                                            class: "pagenation-box rounded-l",
                                            onClick: _cache[0] || (_cache[0] = ($event) => ($options.calcPageNum($data.nowPage - 1)))
                                        }, " 前 "))
                                        : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.pagenation, (page) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                            key: page.id,
                                            style: _normalizeStyle($options.isFormat(page)),
                                            class: "pagenation-box",
                                            onClick: ($event) => ($options.calcPageNum(page))
                                        }, _toDisplayString(page), 13, _hoisted_40));
                                    }), 128)),
                                    ($data.nowPage !== $data.pageNum)
                                        ? (_openBlock(), _createElementBlock("li", {
                                            key: 1,
                                            class: "pagenation-box rounded-r",
                                            onClick: _cache[1] || (_cache[1] = ($event) => ($options.calcPageNum($data.nowPage + 1)))
                                        }, " 次 "))
                                        : _createCommentVNode("", true)
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ])
        ]),
        _withDirectives(_createElementVNode("div", {
            class: "overlay",
            onClick: _cache[4] || (_cache[4] = _withModifiers(
            //@ts-ignore
            (...args) => ($options.closeModal && $options.closeModal(...args)), ["self"]))
        }, [
            _createElementVNode("div", _hoisted_41, [
                _hoisted_42,
                _createElementVNode("div", _hoisted_43, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.requestDetail, (req) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: req.id,
                            class: "whitespace-pre-wrap",
                            style: { "padding": "15px" }
                        }, [
                            _createElementVNode("table", _hoisted_44, [
                                _createElementVNode("tbody", null, [
                                    _hoisted_45,
                                    _createElementVNode("tr", null, [
                                        _createElementVNode("td", null, [
                                            _createElementVNode("label", _hoisted_46, _toDisplayString(req.name), 1)
                                        ])
                                    ]),
                                    _hoisted_47,
                                    _createElementVNode("tr", null, [
                                        _createElementVNode("td", null, [
                                            _createElementVNode("button", {
                                                class: "btn-copy text-xs ml-2",
                                                onClick: _cache[2] || (_cache[2] = ($event) => ($options.crmLink($data.request.customerId)))
                                            }, [
                                                _createVNode(_component_font_awesome_icon, {
                                                    icon: "database",
                                                    size: "lg"
                                                })
                                            ]),
                                            _createElementVNode("label", _hoisted_48, _toDisplayString(req.customerNo), 1)
                                        ])
                                    ]),
                                    (req.zipCd != '')
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_49, _hoisted_51))
                                        : _createCommentVNode("", true),
                                    (req.zipCd != '')
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_52, [
                                            _createElementVNode("td", null, [
                                                _withDirectives((_openBlock(), _createElementBlock("button", {
                                                    class: "btn-copy text-xs ml-2",
                                                    onClick: ($event) => ($options.copyToClipboard(req.zipCd))
                                                }, [
                                                    _createVNode(_component_font_awesome_icon, {
                                                        icon: "copy",
                                                        size: "lg"
                                                    })
                                                ], 8, _hoisted_53)), [
                                                    [_directive_tooltip, {
                                                            content: 'クリックでコピーします',
                                                        }]
                                                ]),
                                                _createElementVNode("label", _hoisted_54, _toDisplayString(req.zipCd), 1)
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    (req.pref != '')
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_55, _hoisted_57))
                                        : _createCommentVNode("", true),
                                    (req.pref != '')
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_58, [
                                            _createElementVNode("td", null, [
                                                _withDirectives((_openBlock(), _createElementBlock("button", {
                                                    class: "btn-copy text-xs ml-2",
                                                    onClick: ($event) => ($options.copyToClipboard(req.pref))
                                                }, [
                                                    _createVNode(_component_font_awesome_icon, {
                                                        icon: "copy",
                                                        size: "lg"
                                                    })
                                                ], 8, _hoisted_59)), [
                                                    [_directive_tooltip, {
                                                            content: 'クリックでコピーします',
                                                        }]
                                                ]),
                                                _createElementVNode("label", _hoisted_60, _toDisplayString(req.pref), 1)
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    (req.cityName != '')
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_61, _hoisted_63))
                                        : _createCommentVNode("", true),
                                    (req.cityName != '')
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_64, [
                                            _createElementVNode("td", null, [
                                                _withDirectives((_openBlock(), _createElementBlock("button", {
                                                    class: "btn-copy text-xs ml-2",
                                                    onClick: ($event) => ($options.copyToClipboard(req.cityName))
                                                }, [
                                                    _createVNode(_component_font_awesome_icon, {
                                                        icon: "copy",
                                                        size: "lg"
                                                    })
                                                ], 8, _hoisted_65)), [
                                                    [_directive_tooltip, {
                                                            content: 'クリックでコピーします',
                                                        }]
                                                ]),
                                                _createElementVNode("label", _hoisted_66, _toDisplayString(req.cityName), 1)
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    (req.streetAddress != '')
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_67, _hoisted_69))
                                        : _createCommentVNode("", true),
                                    (req.streetAddress != '')
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_70, [
                                            _createElementVNode("td", null, [
                                                _withDirectives((_openBlock(), _createElementBlock("button", {
                                                    class: "btn-copy text-xs ml-2",
                                                    onClick: ($event) => ($options.copyToClipboard(req.streetAddress))
                                                }, [
                                                    _createVNode(_component_font_awesome_icon, {
                                                        icon: "copy",
                                                        size: "lg"
                                                    })
                                                ], 8, _hoisted_71)), [
                                                    [_directive_tooltip, {
                                                            content: 'クリックでコピーします',
                                                        }]
                                                ]),
                                                _createElementVNode("label", _hoisted_72, _toDisplayString(req.streetAddress), 1)
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    (req.phoneNum != '')
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_73, _hoisted_75))
                                        : _createCommentVNode("", true),
                                    (req.phoneNum != '')
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_76, [
                                            _createElementVNode("td", null, [
                                                _withDirectives((_openBlock(), _createElementBlock("button", {
                                                    class: "btn-copy text-xs ml-2",
                                                    onClick: ($event) => ($options.copyToClipboard(req.phoneNum))
                                                }, [
                                                    _createVNode(_component_font_awesome_icon, {
                                                        icon: "copy",
                                                        size: "lg"
                                                    })
                                                ], 8, _hoisted_77)), [
                                                    [_directive_tooltip, {
                                                            content: 'クリックでコピーします',
                                                        }]
                                                ]),
                                                _createElementVNode("label", _hoisted_78, _toDisplayString(req.phoneNum), 1)
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    (req.mobilePhoneNum != '')
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_79, _hoisted_81))
                                        : _createCommentVNode("", true),
                                    (req.mobilePhoneNum != '')
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_82, [
                                            _createElementVNode("td", null, [
                                                _withDirectives((_openBlock(), _createElementBlock("button", {
                                                    class: "btn-copy text-xs ml-2",
                                                    onClick: ($event) => ($options.copyToClipboard(req.mobilePhoneNum))
                                                }, [
                                                    _createVNode(_component_font_awesome_icon, {
                                                        icon: "copy",
                                                        size: "lg"
                                                    })
                                                ], 8, _hoisted_83)), [
                                                    [_directive_tooltip, {
                                                            content: 'クリックでコピーします',
                                                        }]
                                                ]),
                                                _createElementVNode("label", _hoisted_84, _toDisplayString(req.mobilePhoneNum), 1)
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ]));
                    }), 128))
                ]),
                _createElementVNode("div", _hoisted_85, [
                    ($data.request.isComplated === $data.userUpdateReq.OPEN.code)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-red dialog-button",
                            onClick: _cache[3] || (_cache[3] = ($event) => ($options.complate($data.request.id)))
                        }, " 対応完了 "))
                        : ($data.request.isComplated === $data.userUpdateReq.CLOSED.code)
                            ? (_openBlock(), _createElementBlock("button", _hoisted_86, " 対応済 "))
                            : _createCommentVNode("", true)
                ])
            ])
        ], 512), [
            [_vShow, $data.showContent]
        ])
    ], 64));
}
